import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { Link, useNavigate } from 'react-router-dom';
import { Award, BookOpen, CheckCircle, Clock, DollarSign, Download, Heart, Info, LogIn, LogOut, MessageSquare, Moon, PieChart, Settings, Star, Sun, User, Users } from 'react-feather';
import { useAuth, useMessage } from '../../global-components/src';
import { useTheme } from '../../global-components/src';
import { Gamepad2, LayoutGrid, Clipboard, Megaphone, History, Wallet, Bookmark, BookCheck, Book, NotebookPen, BookOpenCheck, PlusCircle, LayoutDashboard } from 'lucide-react';
import { CRONOS_URL, ECHO_URL, NUESTRA_URL, PACOCA_URL, READBOOKS_URL } from '../../global-components/src/utils/vars';
import Nav from '../../global-components/src/components/navbar-right/navbar-right';
import NavbarRightLink from '../../global-components/src/components/navbar-right/navbar-right-link';
import AppsNavbarRight from '../../global-components/src/components/navbar-right/apps-link-right';
import { Icon } from '../../global-components/src/components/icon';
import { t } from 'i18next';
import { navigateNav } from '../../global-components/src/utils/nav';

const NavbarRight: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { setMessage } = useMessage();
    const closeRef = useRef<HTMLButtonElement>(null);
    const { isSuper } = useAuth();
    const { isDarkMode } = useTheme();
 
    const copyReferralCode = () => {
        if (navigator.clipboard && navigator.clipboard.writeText && user?.referral_code) {
            navigator.clipboard.writeText(`${PACOCA_URL}/cadastro?referral_code=${user.referral_code}`)
                .then(() => setMessage("Envie para seus amigos! É necessário verificar o email", "success", "Link copiado"))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        }
        closeRef.current?.click()
    }


    return (
        <>
            <Nav closeRef={closeRef}>
                <AppsNavbarRight/>
                
                <span  data-bs-toggle="dropdown" aria-expanded="false" className="link-menu-right dropdown-item color-red">
                    <span className="dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <BookOpenCheck className='menu-father-icon'/>  Leitura
                    </span>
            
                    <ul className="dropdown-menu cursor-pointer" aria-labelledby="navbarDropdown" style={{ width: "100%" }}>
                        <li>
                            <span onClick={(e) => navigate("/catalogo")} className="link-menu-right dropdown-item d-flex align-items-center">
                                <PlusCircle style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Adicionar livro
                            </span>
                        </li>
                        <li>
                            <span onClick={(e) => navigate("/livros/publicados")} className="link-menu-right dropdown-item d-flex align-items-center">
                                <BookOpen style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Livros com PDF
                            </span>
                        </li>
                        <li>
                            <span onClick={(e) => navigate("/dashboard")} className="link-menu-right dropdown-item d-flex align-items-center">
                                <LayoutDashboard style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Dashboard
                            </span>
                        </li>
                    </ul>
                </span>

                <span  data-bs-toggle="dropdown" aria-expanded="false" className="link-menu-right dropdown-item color-red">
                    <span className="dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <NotebookPen className='menu-father-icon'/>  Escritor
                        
                    </span>
            
                    <ul className="dropdown-menu cursor-pointer" aria-labelledby="navbarDropdown" style={{ width: "100%" }}>
                        <li>
                            <span onClick={(e) => navigate("/catalogo")} className="link-menu-right dropdown-item d-flex align-items-center">
                                <BookCheck style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Livro publicados
                            </span>
                        </li>
                        <li>
                            <span onClick={(e) => navigate("/livros/publicar")} className="link-menu-right dropdown-item d-flex align-items-center">
                                <BookCheck style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Publicar livro
                            </span>
                        </li>
                        <li>
                            <span onClick={(e) => navigate("/autor/ganhos")} className="link-menu-right dropdown-item d-flex align-items-center">
                                <BookCheck style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                Meus Ganhos
                            </span>
                        </li>
                    </ul>
                </span>
                <span  data-bs-toggle="dropdown" aria-expanded="false" className="link-menu-right dropdown-item color-red">
                    <span className="dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <Icon invertColor={!isDarkMode} name="admin_panel_settings" size={30}>
                        </Icon> Administrar
                        
                    </span>
            
                    {user && (user?.position > 0 || user?.stamps?.includes("brown")) ? (
                        <ul className="dropdown-menu cursor-pointer" aria-labelledby="navbarDropdown" style={{ width: "100%" }}>
                            <li>
                                <span onClick={(e) => navigate("admin/livros")} className="link-menu-right dropdown-item d-flex align-items-center">
                                    <Book style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                    Livros pendentes 
                                </span>
                            </li>
                            <li>
                                <span onClick={(e) => navigate("/admin/saques")} className="link-menu-right dropdown-item d-flex align-items-center">
                                    <BookCheck style={{ height: '20px', marginRight: '2px', marginTop: 3 }}/>
                                    Saques
                                </span>
                            </li>
                        </ul>
                    ): null}
                </span>
            </Nav>
        </>
    );
};

export default NavbarRight;
